var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fonction"},[_vm._v(" Graphic Designer & Developer ")])}
var staticRenderFns = []

export { render, staticRenderFns }